<template>
  <tr
    style="cursor:pointer;"
    @click="viewItem"
  >
    <td>
      {{ item.Title }}
      <v-chip
        v-show="isUnread"
        color="red"
        small
      >NEW</v-chip>
      <v-chip
        v-show="item.justReaded"
        color="primary"
        small
      >剛剛已讀</v-chip>
    </td>
    <!-- 以下手機版不顯示 -->
    <!-- <td v-show="!isMobile">{{ announcementName }}</td> -->
    <!-- 以上手機版不顯示 -->
    <td>
      <v-icon
        class="ml-1 mr-1"
        @click.stop="viewItem"
      >mdi-eye</v-icon>
      <v-icon
        v-if="canEditThisAnnouncement"
        class="ml-1 mr-1"
        @click.stop="editItem"
      >edit</v-icon>
      <v-icon
        v-if="canDeleteThisAnnouncement"
        class="ml-1 mr-1"
        @click.stop="confirmDeleteItem"
      >delete</v-icon>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    isUnread() {
      return (
        !this.item.ReadedUserIDList ||
        !this.item.ReadedUserIDList.includes(this.me.ID)
      );
    },
    canEditThisAnnouncement() {
      return this.canEditAnnouncement && this.canDeleteThisAnnouncement;
    },
    canDeleteThisAnnouncement() {
      let isCreatedBySelf = this.item.CreatedBy == this.me.ID;
      return this.myLevel >= 1000 || (isCreatedBySelf && this.myLevel >= 10);
    },
    ...mapGetters(["me", "myLevel", "canEditAnnouncement"])
  },
  methods: {
    viewItem() {
      this.$emit("view", this.item.ID);
    },
    editItem() {
      this.$emit("edit", this.item.ID);
    },
    confirmDeleteItem() {
      if (!confirm("確定刪除「" + (this.item.Title || "") + "」?")) return;
      this.$emit("remove", this.item);
    }
  }
};
</script>